import { Box } from '@mui/material'
import React, { useEffect, useState, useContext } from 'react'
import { toast } from 'react-toastify';
import Main from '../components/Main';
import MainHeader from '../components/MainHeader'
import { AuthContext } from '../utils/AuthContext';
import { PAGE_KEYS, usePersistedPageState } from '../utils/pageState';
import CustomTobPlanForm from '../components/auto_quotation/CustomTobPlanForm';
import { DEFAULT_TOB_LANGUAGE, fetchTOBBenefits } from '../services/TOBService';

function MyTobPlans() {

  const { auth } = useContext(AuthContext);

  const [open, setOpen] = useState(localStorage.getItem('quoting-drawer-open') == 'true');

  // What was fetched last time is shown straight away, and the fresh copy replaces it
  // quietly once it arrives -- the spinner is only for a first visit with nothing cached.
  const page = usePersistedPageState(PAGE_KEYS.myTobPlans);
  const [tobBenefitLabelsColumn, setTobBenefitLabelsColumn] = page.useState('tobBenefitLabelsColumn', undefined);
  const [customTobPlans, setCustomTobPlans] = page.useState('customTobPlans', undefined);
  const [loadingTobBenefits, setLoadingTobBenefits] = useState(!tobBenefitLabelsColumn);

  // Every plan column is built against the benefit labels, so they load before the form.
  useEffect(() => {
    fetchTOBBenefits({ planIds: ['benefit_labels'], language: DEFAULT_TOB_LANGUAGE, token: auth.token })
      .then(response => {
        if (response?.data?.table) setTobBenefitLabelsColumn(response.data.table);
      })
      .catch(() => toast.error('Failed to load TOB benefit labels.'))
      .finally(() => setLoadingTobBenefits(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.token]);

  return (
    // The page is exactly one screen tall so the title, chips and toolbar stay put and only
    // the table scrolls, in whatever height is left below them.
    <Box sx={{ display: 'flex', background: '#f9f9f9', height: '100vh', overflow: 'hidden' }}>
      <MainHeader open={open} setOpen={setOpen} />
      <Main open={open} sx={{ pt: 7, minWidth: 0, display: 'flex', flexDirection: 'column' }} >
        <Box sx={{ mt: 4, flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <CustomTobPlanForm
            tobBenefitLabelsColumn={tobBenefitLabelsColumn}
            loadingTobBenefits={loadingTobBenefits}
            token={auth.token}
            initialPlans={customTobPlans}
            onPlansChange={setCustomTobPlans}
            fillHeight
            titleProps={{ variant: 'h4', sx: { fontWeight: 600 } }}
            renderLayout={({ header, content }) => (
              <>
                <Box sx={{ mb: 2 }}>{header}</Box>
                <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>{content}</Box>
              </>
            )}
          />
        </Box>
      </Main>
    </Box>
  )
}

export default MyTobPlans
